
import React, { useEffect } from 'react';
import "./style.css";
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getLocalStorage } from '../../utils/localStorage';
import { AiOutlineDatabase } from 'react-icons/ai';
import { FaFileUpload } from 'react-icons/fa';


function ProccessAdminClientMainScreen(props) {
    const { pathname } = useLocation();   
    const CheckPermission = () => {
        const { role,designation } = getLocalStorage("CURRENT_USER");
          const isAdmin = designation.includes("Admin");
        const links = [

            {
                title: 'Process Admin',
                links: [
                    { name: 'Metadata', path: '/home/processRecordAllocation/clientrecord', icon: <AiOutlineDatabase />, allowed: ["ROLE_ADMIN", ] },
                    { name: 'All Records', path: '/home/processRecordAllocation/records', icon: <AiOutlineDatabase />, allowed: ["ROLE_ADMIN", ] },
                    // { name: 'File Process', path: '/home/processRecordAllocation/fileupload', icon: <FaFileUpload />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },
                ],
                Permissions: ["ROLE_ADMIN"]
            },
             {
                title: 'Process Manager',
                links: [
                    { name: 'Metadata', path: '/home/processRecordAllocation/clientrecord', icon: <AiOutlineDatabase />, allowed: [ "ROLE_MANAGER"] },
                    { name: 'All Records', path: '/home/processRecordAllocation/records', icon: <AiOutlineDatabase />, allowed: [ "ROLE_MANAGER"] },
                    { name: 'File Process', path: '/home/processRecordAllocation/fileupload', icon: <FaFileUpload />, allowed: [ "ROLE_MANAGER"] },
                ],
                Permissions: ["ROLE_MANAGER"]
            }

        ]

        let list = [];
        for (let obj of links) {
            // Check if any role in the role array matches any permission in the Permissions array
            if (role.some(r => obj.Permissions.includes(r))) {
                let innerList = [];
                for (let key of obj.links) {
                    // Check if any role in the role array is allowed for the link
                    if (role.some(r => key.allowed.includes(r))) {
                        innerList.push(key);
                    }
                }
                let tempObj = obj;
                tempObj.links = innerList;
                list.push(tempObj);
            }
        }
        return list;
    }

    const checkActivePath = (screen) => {
        const str = pathname.split("/");
        const path = screen.split("/")
        if (
            str[0] === path[0] &&
            str[1] === path[1] &&
            str[2] === path[2] &&
            str[3] === path[3]) {
            return true;
        } else {
            return false;
        }

    }


    return (
        <div style={{ marginTop: 0, padding: 10, overflow: "hidden", fontFamily: "gb Regular" }}>

            {CheckPermission().map((item) => (

                <div key={item.title} className='pa-top-bar'>
                    {item.links.map((link) => (
                        <NavLink
                            className="pa-CustomLink"
                            to={`${link.path}`}
                            key={link.name}
                            style={
                                checkActivePath(link.path) ?
                                    {
                                        backgroundColor: "#1fafe5ff",
                                        color: "#fff",
                                        fontWeight: 800,
                                    } : {
                                        backgroundColor: '#fff',
                                        color: 'rgb(96 82 82',
                                        fontWeight: 800,
                                    }
                            }

                        >
                            {link.icon}
                            <span className="capitalize">{link.name}</span>
                        </NavLink>
                    ))}
                </div>

            ))}
            <div className='pa-main-outlet'>
                <Outlet ></Outlet>
            </div>

        </div>
    )
}


export default ProccessAdminClientMainScreen;